import logoSanDiego from "../assets/images/LogoSanDiego-01.png"
import logoSanDiegoSvg from "../assets/images/LogoSanDiego-01.svg"
import logoSanDiego2x from "../assets/images/LogoSanDiego-01@2x.png"
import formImg from "../assets/images/formImg.png"
import homeImg from "../assets/images/homeImg.png"
import searchPqr from "../assets/images/searchPqr.png"

const images = {
	logoSanDiego,
	logoSanDiegoSvg,
	logoSanDiego2x,
	formImg,
	homeImg,
	searchPqr,
}

export default images
